module.exports = __webpack_public_path__ + "img/practice.2850e635.png";